<template>
    <v-container class="mt-8" >
        <v-row >
           <v-col cols="12" sm="6" md="4" class="mb-0 pb-0 pt-0 mt-0" v-for="(singleTable, index) in FOODS" :key="index" >
        
                <v-simple-table class="mb-4">
                <table class="mb-0 pb-0">
                    <thead> 
                        <tr class="lunch-table-header">
                            <th colspan="2" >
                                {{ singleTable.HEADER }}
                            </th>
                        </tr>
                    </thead>
                    <tbody v-for="(restaurant, index) in singleTable.Restaurants" :key="index">
                        <th class="w-33">
                            <a :href=restaurant.url>
                                {{ restaurant.name }}
                            </a> 
                        </th>
                        <td class="w-66">
                            {{ restaurant.genre }}
                        </td>
                    </tbody>
                </table>
                </v-simple-table>
                     
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
//import ruokalista from "http://192.168.0.105:5000/public/ruokalista.json";

export default {
    name: 'App',
    data() {
        return {
            FOODS: '',
        }
    },
    methods: {
        getData() {
            let path = "/others.json";
            fetch(path)
            .then(res => res.json())
            .then((out) => {
               this.FOODS = out;
            })
            .catch(err => { throw err });
        }
    },
    mounted() {
        this.getData();
    }
}
</script>



<style scoped>
a {
    color: #0067a7 !important;
    text-decoration: none;
}
a:hover {
    color: #0c0c0c;
    text-decoration: underline;
}

.lunch-table-header {
    text-align: center;
    background-color: #e6e6e6;
}

thead, th {
    border-bottom-width: 2px;
    vertical-align: bottom;
    border-bottom: 2px solid #e9ecef;
    border: 1px solid #e9ecef;
    padding: 4px;
}

td {
    border: 1px solid #e9ecef;
    padding-left: 10px;
}


table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 0.01rem;
    background-color: transparent;
    border-collapse: collapse;
    border: 1px solid #e9ecef;
    display: table;
    white-space: normal;
    line-height: normal;
    font-weight: normal;
    font-size: medium;
    font-style: normal;
    color: -internal-quirk-inherit;
    text-align: start;
    border-spacing: 2px;
    font-variant: normal;
}

.w-66 {
    width: 66% !important;
}
.w-33 {
    width: 33% !important;
}


</style>